/**
 * This script toggles burger navigation
 */

const data = {
	navLevel: 'data-level-open',
};

/**
 * updateNavLevel
 *
 * @param handler
 * @returns {void}
 */
export function updateNavLevel(nr: number = 1): void {
	$(`[${data.navLevel}]`).attr(`${data.navLevel}`, nr);
}

/**
 * Returns the current navigation Level
 */
export function getNavLevel(): number {
	return parseInt($(`[${data.navLevel}]`).attr(`${data.navLevel}`));
}

export default { getNavLevel, updateNavLevel };
